export { default as PauseSolidIcon } from './PauseSolidIcon';
